




























import { getCsvDownloadFunction } from '@/http/utils'
import { PATIENT_STATS_PAGE_TYPES } from '@/utils/constants'

export default {
  props: {
    active: {
      type: String,
      default: '',
    },
    buttons: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      commonRouterLinkParam: {
        name: 'patient-stats',
        param: {
          patient_id: this.$route.patient_id,
        },
      },
    }
  },
  computed: {
    patientId() {
      return this.$route.params.patient_id
    },
    downloadData() {
      switch (this.active) {
        case PATIENT_STATS_PAGE_TYPES.MAPPING.key:
          return {
            is: 'router-link',
            target: '_blank',
            to: {
              name: 'patient-report',
              params: {
                patient_id: this.patientId,
              },
            },
          }
        /*
        case PATIENT_STATS_PAGE_TYPES.NOTES.key:
          return {
            is: 'div',
            on: {
              click: getCsvDownloadFunction({ path: `events-and-notes/patient/${this.patientId}` }),
            },
          }
          */
        default:
          return null
      }
    },
  },
}
